import { render } from "./RoomSpecification.vue?vue&type=template&id=0b504396"
import script from "./RoomSpecification.vue?vue&type=script&lang=js"
export * from "./RoomSpecification.vue?vue&type=script&lang=js"

import "./RoomSpecification.vue?vue&type=style&index=0&id=0b504396&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__